import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import Select from 'react-select';

import { ATTENDANCE_REASON_OPTIONS } from '../../Attendance/attendance.constants';

interface IRsvpReasonFormProps {
  reason: AttendanceReason | '';
  onReasonChange: (reason: AttendanceReason | '') => void;
  reasonNote: string;
  onReasonNoteChange: (note: string) => void;
  onSubmit: () => void;
  submitting: boolean;
  accent: string;
}

// Reason capture for a "not attending" RSVP. Reason is required; the "other"
// option reveals a required free-text note. The button stays enabled and
// validates on click (per REACT_CONVENTIONS.md submit-button rule).
export const RsvpReasonForm: React.FC<IRsvpReasonFormProps> = ({
  reason,
  onReasonChange,
  reasonNote,
  onReasonNoteChange,
  onSubmit,
  submitting,
  accent,
}) => {
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleClick = () => {
    if (!reason) {
      setValidationError('Please choose a reason.');
      return;
    }
    if (reason === 'other' && !reasonNote.trim()) {
      setValidationError('Please add a note for the "Other" reason.');
      return;
    }
    setValidationError(null);
    onSubmit();
  };

  const selectedOption = ATTENDANCE_REASON_OPTIONS.find((option) => option.value === reason) || null;

  return (
    <Box>
      <Box mb={2} style={{ textAlign: 'left' }}>
        <Select
          placeholder="Choose a reason..."
          options={ATTENDANCE_REASON_OPTIONS}
          value={selectedOption}
          onChange={(option: any) => {
            onReasonChange(option ? option.value : '');
            setValidationError(null);
          }}
        />
      </Box>
      {reason === 'other' && (
        <Box mb={2}>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            label="Tell us more"
            value={reasonNote}
            onChange={(e) => {
              onReasonNoteChange(e.target.value);
              setValidationError(null);
            }}
          />
        </Box>
      )}
      {validationError && (
        <Typography variant="body2" gutterBottom style={{ color: '#f04141' }}>{validationError}</Typography>
      )}
      <Button
        variant="contained"
        onClick={handleClick}
        disabled={submitting}
        style={{ background: accent, color: '#ffffff' }}
      >
        {submitting ? 'Submitting…' : 'Submit response'}
      </Button>
    </Box>
  );
};
